import { UContainer } from '@src/components'

import { SigninMain } from './signin-main'

export const PresidentSigninPage = () => {
  return (
    <UContainer maxWidth="lg">
      <SigninMain />
    </UContainer>
  )
}
